<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="合同管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="合同名称">
									<el-input v-model="searchForm.name" placeholder="请填写合同名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="合同编码">
									<el-input v-model="searchForm.contract_code" placeholder="请填写合同编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="签署主体">
									<el-select v-model="searchForm.relevance" placeholder="请选择签署主体" clearable>
										<el-option v-for="item in options.relevance_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="审核状态">
									<el-select v-model="searchForm.status" placeholder="请选择审核状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="合同类型">
									<el-select v-model="searchForm.type" placeholder="请选择合同类型" clearable>
										<el-option v-for="item in options.type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="创建日期">
									<el-date-picker v-model="searchForm.create_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/createcontract') || $parent.$parent.isAuthAction('admin/customers/export/exportcontractexcel')">
								<div>
									<el-button type="primary" size="mini" @click="addContractOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/createcontract')">添加合同</el-button>
								</div>
								<div style="margin-right:10px">
									<el-link type="primary" :disabled="isDownloading" icon="el-icon-download" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportcontractexcel')">{{ isDownloading ?
											'下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id" border stripe ref="table"
									highlight-current-row v-loading="loading" @sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed prop="contract_code" label="合同编码" min-width="150">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.contract_code }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="合同名称" min-width="250">
										<template slot-scope="scope">
											<el-tooltip :content="scope.row.name" placement="top" effect="dark">
												<div style="height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{
													scope.row.name }}</div>
											</el-tooltip>
										</template>
									</el-table-column>
									<el-table-column prop="rid" label="公司名称" min-width="200">
									</el-table-column>
									<el-table-column prop="relevance_txt" label="签署主体" width="80">
									</el-table-column>
									<el-table-column prop="type_txt" label="合同类型" width="80">
									</el-table-column>
									<el-table-column prop="related_contracts" label="关联合同" width="150">
									</el-table-column>
									<el-table-column prop="first_party" label="签订方(甲)" width="150">
									</el-table-column>
									<el-table-column prop="second_party" label="签订方(乙)" width="150">
									</el-table-column>
									<el-table-column prop="third_party" label="签订方(丙)" width="150">
									</el-table-column>
									<el-table-column prop="sign_time" label="签订日期" width="100">
									</el-table-column>
									<el-table-column label="有效期" width="200">
										<template slot-scope="scope">
											{{ scope.row.sign_start_time }}~{{ scope.row.sign_end_time }}
										</template>
									</el-table-column>
									<el-table-column prop="is_lock" label="是否锁价" width="80">
										<template slot-scope="scope">
											<el-switch @change="handleTableBlack(scope.row)" v-model="scope.row.is_lock" active-value='YES'
												inactive-value='NO' :disabled='scope.row.status == 2 || scope.row.status == 4'>
											</el-switch>
										</template>
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="150" sortable="custom">
									</el-table-column>
									<el-table-column prop="uid_txt" label="操作人" width="80">
									</el-table-column>
									<el-table-column prop="pigeonhole_status_txt" label="归档状态" width="80">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatecontract') || $parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitcontract') || $parent.$parent.isAuthAction('admin/customers/customer/deletecontract')"
										min-width="150">
										<template slot-scope="scope">
											<template v-if="scope.row.status == 1 || scope.row.status == 3">
												<el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatecontract')">编辑</el-button>
												<el-button @click="handleTableFlow(scope.row)" type="text" :size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitcontract')">提交审批</el-button>
												<el-button @click="handleTableDelete(scope.row)"
													v-if="isSupper && $parent.$parent.isAuthAction('admin/customers/customer/deletecontract')"
													type="text" :size="size" class="c-danger">删除</el-button>
											</template>
											<template v-else>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatecontract')">编辑</el-button>
												<el-button disabled type="text" :size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitcontract')">提交审批</el-button>
												<el-button disabled
													v-if="isSupper && $parent.$parent.isAuthAction('admin/customers/customer/deletecontract')"
													type="text" :size="size" class="c-danger">删除</el-button>
											</template>
										</template>
									</el-table-column>

								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加合同-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="60%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>添加合同</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="签署主体" prop="relevance">
						<el-select v-model="addForm.relevance" clearable placeholder="请选择" style='width: 100%;'
							@change="getRid('add', 'clear')">
							<el-option v-for="item in options.relevance_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="addForm.relevance == 1 ? '供应商' : '客户'" prop="rid" v-if="addForm.relevance">
						<el-select v-model="addForm.rid" clearable filterable remote reserve-keyword placeholder="请输入名称关键字"
							:remote-method="(query) => getRid('add', 'clear', query)" style='width: 100%;' @change="changeRid('add')">
							<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="合同名称" prop="name">
						<el-input v-model="addForm.name" placeholder="请填写合同名称" clearable maxlength="50" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="合同类型" prop="type" v-if="addForm.rid">
						<el-select v-model="addForm.type" clearable placeholder="请选择" style='width: 100%;'
							@change="getContract('add', 'clear')">
							<el-option v-for="item in options.type_options" :key="item.value" :label="item.label" :value="item.value"
								:disabled="addForm.relevance != 1 && item.value == 3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关联合同" prop="related_contracts" v-if="addForm.type == 4">
						<el-select v-model="addForm.related_contracts" clearable placeholder="请选择" style='width: 100%;' filterable
							remote :remote-method="getContractData">
							<el-option v-for="item in options.related_contracts_options" :key="item.value" :label="item.label"
								:value="item.value" :disabled="addForm.relevance != 1 && item.value == 3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="签订日期" prop="sign_time">
						<el-date-picker type="date" placeholder="请选择签订日期" v-model="addForm.sign_time" style="width: 100%;"
							format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="合同有效期" prop="sign_start_end_time">
						<el-col :span="11">
							<el-date-picker type="date" placeholder="开始日期" v-model="addForm.sign_start_time" style="width: 100%;"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-col>
						<el-col style="width: 20px; text-align: center;">-</el-col>
						<el-col :span="11">
							<el-date-picker type="date" placeholder="开始日期" v-model="addForm.sign_end_time" style="width: 100%;"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-col>
					</el-form-item>
					<el-form-item label="合同金额" prop="contract_amount" v-if="addForm.type == 1 && addForm.relevance == 2">
						<el-input v-model="addForm.contract_amount" placeholder="请填写合同金额" clearable></el-input>
					</el-form-item>
					<el-form-item label="是否锁价" prop="is_lock" v-if="addForm.relevance == 2">
						<el-radio-group v-model="addForm.is_lock">
							<el-radio label="YES">是</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="签订方" prop="sign_type" v-if="addForm.relevance == 1">
						<el-select v-model="addForm.sign_type" clearable placeholder="请选择" style='width: 100%;'>
							<el-option v-for="item in options.sign_type_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="甲方" prop="first_party" v-if="addForm.relevance == 1 && addForm.sign_type">
						<el-input v-model="addForm.first_party" placeholder="请填写甲方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="乙方" prop="second_party" v-if="addForm.relevance == 1 && addForm.sign_type">
						<el-input v-model="addForm.second_party" placeholder="请填写乙方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="丙方" prop="third_party" v-if="addForm.sign_type == 2 || addForm.sign_type == 3">
						<el-input v-model="addForm.third_party" placeholder="请填写丙方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="丁方" prop="fourthly_party" v-if="addForm.sign_type == 3">
						<el-input v-model="addForm.fourthly_party" placeholder="请填写丁方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="合同附件" prop='attachment'>
						<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'attachment', true)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'addForm', 'attachment', true)" :on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addContract" :size='size'>提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--编辑合同-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="60%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>编辑合同</span>
						<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="签署主体" prop="relevance">
						<el-select v-model="editForm.relevance" clearable placeholder="请选择" style='width: 100%;'
							@change="getRid('edit', 'clear')">
							<el-option v-for="item in options.relevance_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="editForm.relevance == 1 ? '供应商' : '客户'" prop="rid" v-if="editForm.relevance">
						<el-select v-model="editForm.rid" clearable filterable remote reserve-keyword placeholder="请输入名称关键字"
							:remote-method="(query) => getRid('edit', 'clear', query)" style='width: 100%;'
							@change="changeRid('edit')">
							<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="合同名称" prop="name">
						<el-input v-model="editForm.name" placeholder="请填写合同名称" clearable maxlength="50" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="合同类型" prop="type">
						<el-select v-model="editForm.type" clearable placeholder="请选择" style='width: 100%;'
							@change="getContract('edit', 'clear')">
							<el-option v-for="item in options.type_options" :key="item.value" :label="item.label" :value="item.value"
								:disabled="editForm.relevance != 1 && item.value == 3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关联合同" prop="related_contracts" v-if="editForm.type == 4">
						<el-select v-model="editForm.related_contracts" clearable placeholder="请选择" style='width: 100%;'>
							<el-option v-for="item in options.related_contracts_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="签订日期" prop="sign_time">
						<el-date-picker type="date" placeholder="请选择签订日期" v-model="editForm.sign_time" style="width: 100%;"
							format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="合同有效期" prop="sign_start_end_time">
						<el-col :span="11">
							<el-date-picker type="date" placeholder="开始日期" v-model="editForm.sign_start_time" style="width: 100%;"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-col>
						<el-col style="width: 20px; text-align: center;">-</el-col>
						<el-col :span="11">
							<el-date-picker type="date" placeholder="开始日期" v-model="editForm.sign_end_time" style="width: 100%;"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-col>
					</el-form-item>
					<el-form-item label="合同金额" prop="contract_amount" v-if="editForm.type == 1 && addForm.relevance == 2">
						<el-input v-model="editForm.contract_amount" placeholder="请填写合同金额" clearable></el-input>
					</el-form-item>
					<el-form-item label="是否锁价" prop="is_lock" v-if="editForm.relevance == 2">
						<el-radio-group v-model="editForm.is_lock">
							<el-radio label="YES">是</el-radio>
							<el-radio label="NO">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="签订方" prop="sign_type" v-if="editForm.relevance == 1">
						<el-select v-model="editForm.sign_type" clearable placeholder="请选择" style='width: 100%;'>
							<el-option v-for="item in options.sign_type_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="甲方" prop="first_party" v-if="editForm.relevance == 1 && editForm.sign_type">
						<el-input v-model="editForm.first_party" placeholder="请填写甲方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="乙方" prop="second_party" v-if="editForm.relevance == 1 && editForm.sign_type">
						<el-input v-model="editForm.second_party" placeholder="请填写乙方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="丙方" prop="third_party" v-if="editForm.sign_type == 2 || editForm.sign_type == 3">
						<el-input v-model="editForm.third_party" placeholder="请填写丙方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="丁方" prop="fourthly_party" v-if="editForm.sign_type == 3">
						<el-input v-model="editForm.fourthly_party" placeholder="请填写丁方" clearable maxlength="20"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="合同附件" prop='attachment'>
						<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'attachment', true)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'editForm', 'attachment', true)" :on-preview="viewImg">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
					<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			dialogImageUrl: '',
			isDownloading: false,
			dialogVisibleImg: false,
			addFormVisiable: false,
			editFormVisiable: false,
			checkSkVisiable: false,
			loading: true,
			activeName: 'first',
			size: 'mini',
			options: {
				relevance_options: [
					{
						value: 1,
						label: '供应商'
					}, {
						value: 2,
						label: '客户'
					}
				],
				rid_options: [],//客户、供应商下拉列表
				type_options: [
					{
						value: 1,
						label: '单笔'
					}, {
						value: 2,
						label: '框架'
					}, {
						value: 3,
						label: '供应商补偿协议(供应商专用)'
					}, {
						value: 4,
						label: '补充协议'
					}
				],
				related_contracts_options: [],//关联合同列表
				sign_type_options: [
					{
						value: 1,
						label: '双方'
					}, {
						value: 2,
						label: '三方'
					}, {
						value: 3,
						label: '四方'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
			},
			searchForm: {
				name: '',
				contract_code: '',
				status: '',
				type: '',
				relevance: '',
				create_time: ''
			},
			resetSearch: {
				name: '',
				contract_code: '',
				status: '',
				type: '',
				relevance: '',
				create_time: ''
			},
			addForm: {
				relevance: '',
				rid: '',
				name: '',
				type: '',
				related_contracts: '',
				sign_time: '',
				sign_start_time: '',
				sign_end_time: '',
				contract_amount: '',
				is_lock: '',
				sign_type: '',
				first_party: '',
				second_party: '',
				third_party: '',
				fourthly_party: '',
				attachment: []
			},
			editForm: {
				relevance: '',
				rid: '',
				name: '',
				type: '',
				related_contracts: '',
				sign_time: '',
				sign_start_time: '',
				sign_end_time: '',
				contract_amount: '',
				is_lock: '',
				sign_type: '',
				first_party: '',
				second_party: '',
				third_party: '',
				fourthly_party: '',
				attachment: []
			},
			rules: {
				addForm: {
					'relevance': [
						{ required: true, message: '请选择签署主体', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请填写客户名称', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								if (this.addForm.relevance == 1 && !value) {
									callback(new Error('请选择供应商'));
								} else if (this.addForm.relevance == 2 && !value) {
									callback(new Error('请选择客户'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'name': [
						{ required: true, max: 50, message: '请填写正确的合同名称，长度不超过 50', trigger: ['change', 'blur'] }
					],
					'type': [
						{ required: true, message: '请选择合同类型', trigger: ['change', 'blur'] }
					],
					'related_contracts': [
						{ required: true, message: '请选择关联合同', trigger: ['change'] }
					],
					'sign_time': [
						{ required: true, message: '请填写合同签订日期', trigger: ['change'] }
					],
					'sign_start_end_time': [
						{
							required: true, validator: (rule, value, callback) => {
								const d1 = new Date(this.addForm.sign_start_time);
								const d2 = new Date(this.addForm.sign_end_time);
								if (!this.addForm.sign_start_time || !this.addForm.sign_end_time) {
									callback(new Error('请填写合同有效期'));
								} else if (d1.getTime() > d2.getTime()) {
									callback(new Error('结束日期不得早于开始日期'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'contract_amount': [
						{ required: true, message: '请填写合同金额', trigger: ['change'] }
					],
					'is_lock': [
						{ required: true, message: '请选择是否锁价', trigger: ['change'] }
					],
					'sign_type': [
						{ required: true, message: '请选择签订方', trigger: ['change'] }
					],
					'first_party': [
						{ required: true, message: '请填写甲方信息', trigger: ['change'] }
					],
					'second_party': [
						{ required: true, message: '请填写乙方信息', trigger: ['change'] }
					],
					'third_party': [
						{ required: true, message: '请填写丙方信息', trigger: ['change'] }
					],
					'fourthly_party': [
						{ required: true, message: '请填写丁方信息', trigger: ['change'] }
					],
					'attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.addForm.attachment.length < 1) {
									callback(new Error('请上传合同附件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				editForm: {
					'relevance': [
						{ required: true, message: '请选择签署主体', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请填写客户名称', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								if (this.editForm.relevance == 1 && !value) {
									callback(new Error('请选择供应商'));
								} else if (this.editForm.relevance == 2 && !value) {
									callback(new Error('请选择客户'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'name': [
						{ required: true, max: 50, message: '请填写正确的合同名称，长度不超过 50', trigger: ['change', 'blur'] }
					],
					'type': [
						{ required: true, message: '请选择合同类型', trigger: ['change', 'blur'] }
					],
					'related_contracts': [
						{ required: true, message: '请选择关联合同', trigger: ['change'] }
					],
					'sign_time': [
						{ required: true, message: '请填写合同签订日期', trigger: ['change'] }
					],
					'sign_start_end_time': [
						{
							required: true, validator: (rule, value, callback) => {
								const d1 = new Date(this.editForm.sign_start_time);
								const d2 = new Date(this.editForm.sign_end_time);
								if (!this.editForm.sign_start_time || !this.editForm.sign_end_time) {
									callback(new Error('请填写合同有效期'));
								} else if (d1.getTime() > d2.getTime()) {
									callback(new Error('结束日期不得早于开始日期'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'contract_amount': [
						{ required: true, message: '请填写合同金额', trigger: ['change'] }
					],
					'is_lock': [
						{ required: true, message: '请选择是否锁价', trigger: ['change'] }
					],
					'sign_type': [
						{ required: true, message: '请选择签订方', trigger: ['change'] }
					],
					'first_party': [
						{ required: true, message: '请填写甲方信息', trigger: ['change'] }
					],
					'second_party': [
						{ required: true, message: '请填写乙方信息', trigger: ['change'] }
					],
					'third_party': [
						{ required: true, message: '请填写丙方信息', trigger: ['change'] }
					],
					'fourthly_party': [
						{ required: true, message: '请填写丁方信息', trigger: ['change'] }
					],
					'attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.editForm.attachment.length < 1) {
									callback(new Error('请上传合同附件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			type: ''
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
	},
	methods: {
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		exportData () {
			this.isDownloading = true
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'contract'
			this.$api.get('/admin/customers/export/exportcontractexcel', excelSearch).then(res => {
				// if (res.code == 0) {
				// 		this.$alert('异步下载任务【合同列表下载】创建成功！请稍后查看下载列表', '下载提示', {
				// 			confirmButtonText: '确定',
				// 		});
				// }else{
				// 	this.$message({
				// 		type: 'error',
				// 		message: res.msg
				// 	});
				// }
				// this.isDownloading = false;
				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '合同信息.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象
				this.isDownloading = false
				this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
					confirmButtonText: '确定',
				});
			})
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/getcontractlist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//供应商、客户改变清空合同类型
		changeRid (type) {
			if (type == 'add') {
				this.addForm.type = ''
			} else if (type == 'edit') {
				this.editForm.type = ''
			}
		},
		//获取客户、供应商
		getRid (type, change, query) {
			if (type == 'add') {
				this.addForm.rid = ''
				this.addForm.type = ''
				this.addForm.related_contracts = ''
			} else if (type == 'edit' && change == 'clear') {
				this.editForm.rid = ''
				this.editForm.type = ''
				this.editForm.related_contracts = ''
			}
			if ((this.addForm.relevance == 1 && type == 'add') || (this.editForm.relevance == 1 && type == 'edit')) {
				if (query) {
					var map = { query: query }
				}
				this.$api.get('/admin/resources/resources/supldwn', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if ((this.addForm.relevance == 2 && type == 'add') || (this.editForm.relevance == 2 && type == 'edit')) {
				if (query) {
					var map = { query: query }
				}
				this.$api.get('/admin/customers/customer/getcustomerselect', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			}
		},
		//关联合同需要参数
		getContract (type, change) {
			this.options.related_contracts_options = []
			this.type = type
			if (type == 'add') {
				this.addForm.related_contracts = ''
			} else if (type == 'edit' && change == 'clear') {
				this.editForm.related_contracts = ''
			}
			if (this.addForm.type == 4 || this.editForm.type == 4) {
				this.getContractData()
			}
		},
		//获取关联合同
		getContractData (query) {
			let param = {}
			if (this.type == 'add') {
				param = { id: this.addForm.rid, type: this.addForm.type, relevance: this.addForm.relevance }
			} else if (this.type == 'edit') {
				param = { id: this.editForm.rid, type: this.editForm.type, relevance: this.editForm.relevance }
			}
			if (query) {
				param['query'] = query
			}
			this.$api.get('/admin/customers/customer/getcontractselect', param).then(res => {
				if (res.code === 0) {
					this.options.related_contracts_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},

		// 添加合同弹窗
		addContractOpen () {
			this.addForm = {
				relevance: '',
				rid: '',
				name: '',
				type: '',
				related_contracts: '',
				sign_time: '',
				sign_start_time: '',
				sign_end_time: '',
				contract_amount: '',
				is_lock: '',
				sign_type: '',
				first_party: '',
				second_party: '',
				third_party: '',
				fourthly_party: '',
				attachment: []
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		// 添加合同
		addContract () {
			const formData = new FormData()
			for (const key in this.addForm) {
				if (key == 'attachment') {
					if (this.addForm[key].length > 0) {
						this.addForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/createcontract', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})

				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 打开编辑部门弹窗
		handleTableEditOpen (row) {
			this.$api.get('/admin/resources/resources/contractinfo', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					this.getRid('edit', 'keep')
					this.getContract('edit', 'keep')
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 编辑合同
		handleTableEdit () {
			const formData = new FormData()
			for (const key in this.editForm) {
				if (key == 'attachment') {
					if (this.editForm[key].length > 0) {
						this.editForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.editForm[key]);
				}
			}
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/updatecontract', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '合同信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		// 删除合同
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/deletecontract', { contract_code: row.contract_code }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.contract_code == row.contract_code) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.contract_code == row.contract_code) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该合同已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//点击查看大图
		viewImg (file) {
			if (!file.url) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.url)
				} else {
					this.dialogImageUrl = file.url;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
		//提交审批
		handleTableFlow (row) {
			this.$api.post('/admin/customers/customer/confirmsubmitcontract', { contract_code: row.contract_code }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.contract_code == item.contract_code) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该合同已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'ContractDetail',
				query: { id: row.id, set_id: 1, type: 'detail' }
			});
		},
		//修改锁价状态
		handleTableBlack (row) {
			this.$api.put('/admin/customers/customer/updatelock', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '锁价状态修改成功！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/contractDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>